import { toast } from "react-toastify";

const options = {
	draggable: false,
	position: "top-right",
	autoClose: 3000,
	hideProgressBar: false,
	closeOnClick: true,
	pauseOnHover: true,
	progressClassName: "toast-progress",
	mute: false,
};
class Toast {
	default = (str, myOptions = {}) => {
		if (!str || str === "") return;
		toast(str, { ...options, ...myOptions, className: "toast-msg toast-default" });
	};
	info = (str, myOptions = {}) => {
		if (!str || str === "") return;
		toast.info(str, { ...options, ...myOptions, className: "toast-msg toast-info" });
	};
	success = (str, myOptions = {}) => {
		if (!str || str === "") return;
		toast.success(str, { ...options, ...myOptions, className: "toast-msg toast-success" });
	};
	error = (str, myOptions = {}) => {
		if (!str || str === "") return;		
		toast.error(str, { ...options, ...myOptions, className: "toast-msg toast-error" });
	};
	warning = (str, myOptions = {}) => {
		if (!str || str === "") return;
		toast.warning(str, { ...options, ...myOptions, className: "toast-msg toast-warning" });
	};
}

export default new Toast();
